<template>
  <v-app id="app">
    <toolbar></toolbar>
    <!-- <login v-if="!currentUser"></!-->

    <v-content>
      <v-container fluid class="fill-height px-0 pt-0" white>
        <v-layout row wrap>
          <v-flex xs12>
            <!-- <keep-alive> -->
            <transition name="fade" mode="out-in">
              <router-view></router-view>
            </transition>
            <!-- </keep-alive> -->
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>

    <!-- <login v-else></login> -->
    <!-- <v-footer
      height="auto"
      fixed
      color="primary lighten-1"
    >
      <v-layout
        justify-center
        row
        wrap
      >
        <v-btn
          v-for="link in ['links']"
          :key="link"
          color="white"
          flat
          round
        >
          {{ link }}
        </v-btn>
        <v-flex
          primary
          lighten-2
          py-3
          text-xs-center
          white--text
          xs12
        >
          &copy;2018 — <strong>Vuetify</strong>
        </v-flex>
      </v-layout>
    </v-footer> -->
  </v-app>
</template>

<script>
// import Router from 'vue-router'
// import { mapGetters } from 'vuex'
import { mapGetters, mapState } from 'vuex'
import { AUTH_LOGOUT } from '@/store/actions/auth'

//import Login from '@/components/users/Login.vue'
import Login from '@/components/login'

import Toolbar from '@/components/layout/Toolbar.vue'
import Artists from '@/components/artists/Artists.vue'
import Contacts from '@/components/contacts/Contacts.vue'
import axios from 'axios'
import { USER_REQUEST } from '@/store/actions/user'

export default {
  name: 'app',
  data: () => ({
    dialog: false,
    transitionName: 'slide-left'
    // drawer: null,
    // sheet: false,
    // currentUser: ''
    // currentUser: this.$store.state.currentUser
  }),
  beforeRouteUpdate(to, from, next) {
    const toDepth = to.path.split('/').length
    const fromDepth = from.path.split('/').length
    this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left'
    next()
  },
  computed: {
    token() {
      // console.log(localStorage.getItem('user-token'))
      return localStorage.getItem('user-token')
    }
  },
  props: {
    source: String,
    filters: []
  },
  components: {
    Login,
    Toolbar,
    Artists,
    Contacts
  },
  // computed: {
  //   ...mapGetters({ currentUser: 'currentUser' })
  // },
  created: function() {
    // savedResetDate = localStorage.getItem('last-reset')
    // if (savedResetDate && savedResetDate > Date.now()) {
    //   localStorage.clear()
    // }
    if (this.$store.getters.isAuthenticated) {
      this.$store.dispatch(USER_REQUEST)
    } else {
      this.$router.push('/login')
    }
  },

  // created () {
  // this.checkCurrentLogin()
  // this.currentUser = this.$store.state.users[2]
  // this.currentUser = Object.assign({},this.$store.state.currentUser)

  // },
  updated() {
    // this.checkCurrentLogin()
  },
  methods: {
    // checkCurrentLogin () {
    //   if (!this.currentUser && this.$route.path !== '/') {
    //     this.$router.push('/?redirect=' + this.$route.path)
    //   }
    // }
  }
  // data: {
  //   currentRoute: window.location.pathname
  // },
  // computed: {
  //   ViewComponent () {
  //     return routes[this.currentRoute] || NotFound
  //   }
  // },
  // render (h) { return h(this.ViewComponent) }
}
</script>

<style>
.v-btn--active {
  color: white !important;
  background-color: black;
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
/* #app { */
/* font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50; */
/* margin-top: 60px; */
/* } */
</style>



// WEBPACK FOOTER //
// src/App.vue